import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.95731 10.982C1.39509 11.5442 1.39509 12.4557 1.95731 13.018L10.982 22.0427C11.5442 22.6049 12.4557 22.6049 13.018 22.0427L22.0427 13.018C22.6049 12.4557 22.6049 11.5442 22.0427 10.982L13.018 1.95731C12.4557 1.39509 11.5442 1.39509 10.982 1.95731L1.95731 10.982ZM12.8489 8.711C13.1418 8.41811 13.6167 8.41811 13.9096 8.711L15.9768 10.7782C15.9829 10.7842 15.9889 10.7904 15.9948 10.7967C16.0559 10.8617 16.1033 10.9349 16.1369 11.0127C16.1764 11.1039 16.1982 11.2046 16.1982 11.3103C16.1982 11.4177 16.1757 11.5198 16.1351 11.6121C16.1034 11.6842 16.0598 11.7524 16.0043 11.8136C15.9951 11.8238 15.9855 11.8338 15.9758 11.8434L13.9096 13.9096C13.6167 14.2025 13.1418 14.2025 12.8489 13.9096C12.556 13.6167 12.556 13.1418 12.8489 12.8489L13.6376 12.0603H10.6207C10.2709 12.0603 9.93537 12.1993 9.68801 12.4466C9.44066 12.694 9.3017 13.0295 9.3017 13.3793V14.0689C9.3017 14.4831 8.96591 14.8189 8.5517 14.8189C8.13748 14.8189 7.8017 14.4831 7.8017 14.0689V13.3793C7.8017 12.6316 8.09869 11.9146 8.62735 11.386C9.15601 10.8573 9.87303 10.5603 10.6207 10.5603H13.6376L12.8489 9.77166C12.556 9.47877 12.556 9.0039 12.8489 8.711Z"
        fill={colorValue}
      />
    </svg>
  );
};
